// src/Api/authApi.js
import { post } from "./api"; // assuming your common axios setup is here

export const logoutApi = async () => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await post(
      "/logout",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("Logout successful:", response);
    return response;
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
};
